var MAXIMUM_CUSTOM_REWARD_CHARACTERS = 200;
export default MAXIMUM_CUSTOM_REWARD_CHARACTERS;
